export enum FocusArea {
  AlternativeDisputeResolution = 'AlternativeDisputeResolution',
  AdvertisingTechnology = 'AdvertisingTechnology',
  AntitrustAndCompetition = 'AntitrustAndCompetition',
  ArtificialIntelligence = 'ArtificialIntelligence',
  AssetFinanceAndLeasing = 'AssetFinanceAndLeasing',
  BankruptcyAndReorganization = 'BankruptcyAndReorganization',
  BriberyAndCorruption = 'BriberyAndCorruption',
  CloudSaaSSoftwareLicensing = 'CloudSaaSSoftwareLicensing',
  CommercialBanking = 'CommercialBanking',
  CommercialContracts = 'CommercialContracts',
  CommercialRealEstateAndLeasing = 'CommercialRealEstateAndLeasing',
  ConsumerBankingAndLending = 'ConsumerBankingAndLending',
  ConsumerProtectionRegulation = 'ConsumerProtectionRegulation',
  Copyrights = 'Copyrights',
  CorporateSecretaryAndServices = 'CorporateSecretaryAndServices',
  CorporateTrustsLendingAndBorrowing = 'CorporateTrustsLendingAndBorrowing',
  Cybersecurity = 'Cybersecurity',
  DataPrivacy = 'DataPrivacy',
  DebtCapitalMarkets = 'DebtCapitalMarkets',
  Derivatives = 'Derivatives',
  EmployeeInvestigations = 'EmployeeInvestigations',
  EnergyRegulationAndCompliance = 'EnergyRegulationAndCompliance',
  EnvironmentalSocialAndGovernanceCompliance = 'EnvironmentalSocialAndGovernanceCompliance',
  EquityCapitalMarkets = 'EquityCapitalMarkets',
  ERISACompensationPensionsAndBenefits = 'ERISACompensationPensionsAndBenefits',
  FinancialServicesComplianceAndRegulation = 'FinancialServicesComplianceAndRegulation',
  FinTechAndPayments = 'FinTechAndPayments',
  GeneralCounselServices = 'GeneralCounselServices',
  GeneralEmployment = 'GeneralEmployment',
  GovernmentContracts = 'GovernmentContracts',
  HealthcareRegulatoryAndCompliance = 'HealthcareRegulatoryAndCompliance',
  Insurance = 'Insurance',
  InvestmentAndWealthManagement = 'InvestmentAndWealthManagement',
  InvestmentComplianceAndMarketAccess = 'InvestmentComplianceAndMarketAccess',
  IntellectualPropertyLitigation = 'IntellectualPropertyLitigation',
  LaborRelations = 'LaborRelations',
  ConstructionPlanningAndDevelopment = 'ConstructionPlanningAndDevelopment',
  LegalOperations = 'LegalOperations',
  LifeSciencesCompliance = 'LifeSciencesCompliance',
  LifeSciencesRegulatory = 'LifeSciencesRegulatory',
  LifeSciencesSupplyChain = 'LifeSciencesSupplyChain',
  Litigation = 'Litigation',
  MAndADivestitures = 'MAndADivestitures',
  LifeSciencesMarketAccessAndReimbursement = 'LifeSciencesMarketAccessAndReimbursement',
  MarketingAndAdvertising = 'MarketingAndAdvertising',
  EnergyNuclear = 'EnergyNuclear',
  EnergyOilAndGas = 'EnergyOilAndGas',
  Patents = 'Patents',
  ProcurementAndOutsourcing = 'ProcurementAndOutsourcing',
  ProductCounsel = 'ProductCounsel',
  ClinicalTrials = 'ClinicalTrials',
  RealEstateFinance = 'RealEstateFinance',
  EnergyRenewable = 'EnergyRenewable',
  SecuritiesAndPrimeBrokerage = 'SecuritiesAndPrimeBrokerage',
  StructuredAndProjectFinance = 'StructuredAndProjectFinance',
  SupplyChainTransportation = 'SupplyChainTransportation',
  Tax = 'Tax',
  TradeComplianceSanctionsAndExportControls = 'TradeComplianceSanctionsAndExportControls',
  Trademarks = 'Trademarks',
  EnergyUtilities = 'EnergyUtilities',
  IPLicensing = 'IPLicensing',
  InvestigationsAndEnforcement = 'InvestigationsAndEnforcement',
}

const FocusAreaLabelsForLegacyJsApiUseOnly = {
  AlternativeDisputeResolution: 'Alternative Dispute Resolution',
  AdvertisingTechnology: 'AdTech Law',
  AntitrustAndCompetition: 'Antitrust Law',
  ArtificialIntelligence: 'AI Law',
  AssetFinanceAndLeasing: 'Asset Finance Law',
  BankruptcyAndReorganization: 'Bankruptcy Law',
  BriberyAndCorruption: 'Bribery & Corruption Law',
  CloudSaaSSoftwareLicensing: 'Technology Licensing Law',
  CommercialBanking: 'Commercial Banking Lawyer',
  CommercialContracts: 'Contract Law',
  CommercialRealEstateAndLeasing: 'Commercial Real Estate Law',
  ConsumerBankingAndLending: 'Consumer Banking Law',
  ConsumerProtectionRegulation: 'Consumer Protection Law',
  Copyrights: 'Copyright Law',
  CorporateSecretaryAndServices: 'Corporate Law',
  CorporateTrustsLendingAndBorrowing: 'Corporate Trust Law',
  Cybersecurity: 'Cybersecurity Law',
  DataPrivacy: 'Privacy La',
  DebtCapitalMarkets: 'Debt Capital Markets Law',
  Derivatives: 'Derivatives Law',
  EmployeeInvestigations: 'Employee Investigations Law',
  EnergyRegulationAndCompliance: 'Energy Law',
  EnvironmentalSocialAndGovernanceCompliance: 'ESG Law',
  EquityCapitalMarkets: 'Equity Capital Markets Law',
  ERISACompensationPensionsAndBenefits: 'ERISA and Benefits Law',
  FinancialServicesComplianceAndRegulation: 'Finance Law',
  FinTechAndPayments: 'FinTech & Payments Lawyer',
  GeneralCounselServices: 'GC Services',
  GeneralEmployment: 'Employment Law',
  GovernmentContracts: 'Government Contracts Law',
  HealthcareRegulatoryAndCompliance: 'Healthcare Compliance & Investigations',
  Insurance: 'Insurance Law',
  InvestmentAndWealthManagement: 'Investments Law',
  InvestmentComplianceAndMarketAccess: 'Investment Compliance Law',
  IntellectualPropertyLitigation: 'IP Litigation',
  LaborRelations: 'Labor Relations Law',
  ConstructionPlanningAndDevelopment: 'Real Estate Development Law',
  LegalOperations: 'Legal Ops',
  LifeSciencesCompliance: 'Life Sciences Compliance',
  LifeSciencesRegulatory: 'Life Sciences Regulatory Advice & Counsel',
  LifeSciencesSupplyChain: 'Life Sciences Supply Chain Law',
  Litigation: 'Litigation',
  MAndADivestitures: 'M&A Law',
  LifeSciencesMarketAccessAndReimbursement: 'Life Sciences Market Access Law',
  MarketingAndAdvertising: 'Marketing Law',
  EnergyNuclear: 'Nuclear Energy Law',
  EnergyOilAndGas: 'Oil & Gas Law',
  Patents: 'Patent Law',
  ProcurementAndOutsourcing: 'Procurement Law',
  ProductCounsel: 'Product Law',
  ClinicalTrials: 'Clinical Trials Law',
  RealEstateFinance: 'Real Estate Finance Law',
  EnergyRenewable: 'Renewable Energy Law',
  SecuritiesAndPrimeBrokerage: 'Securities Law',
  StructuredAndProjectFinance: 'Structured & Project Finance Law',
  SupplyChainTransportation: 'Supply Chain Law',
  Tax: 'Tax Law',
  TradeComplianceSanctionsAndExportControls: 'Trade Law',
  Trademarks: 'Trademark Law',
  EnergyUtilities: 'Utilities Law',
  IPLicensing: 'IP Licensing Law',
  InvestigationsAndEnforcement:
    'Regulatory & Compliance Investigations & Enforcement Counsel',
};

export const FocusAreaLabelsMap = new Map(
  Object.entries(FocusAreaLabelsForLegacyJsApiUseOnly)
);
